import React, { createContext, useContext, useState, useEffect, ReactNode } from "react";

interface ExpireHashContextProps {
  expireHashShare: string;
  setExpireHashShare: React.Dispatch<React.SetStateAction<string>>;
}

const ExpireHashContext = createContext<ExpireHashContextProps | undefined>(undefined);

export const ExpireHashProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [expireHashShare, setExpireHashShare] = useState(() => {
    const savedHash = localStorage.getItem("expireHashShare");
    return savedHash || "";
  });

  useEffect(() => {
    localStorage.setItem("expireHashShare", expireHashShare);
  }, [expireHashShare]);

  return (
    <ExpireHashContext.Provider value={{ expireHashShare, setExpireHashShare }}>
      {children}
    </ExpireHashContext.Provider>
  );
};

export const useExpireHash = () => {
  const context = useContext(ExpireHashContext);
  if (!context) {
    throw new Error("useExpireHash must be used within an ExpireHashProvider");
  }
  return context;
};